<template minapp="mpx" xlang="wxml">
  <view class="es-train-information">
    <view class="es-train-information-item">
      <view class="es-train-info-date">{{ startTime.date }} {{ startTime.week }}</view>
      <view class="es-train-info-time">{{ startTime.time }}</view>
      <view class="es-train-station-name">
        {{ fromStationName }}
        <image
          wx:style="width: 12px; height: 12px; margin-left: 2px"
          src="{{isStartStation ? 'https://pt-starimg.didistatic.com/static/starimg/img/YxaFxD0mks1646826526250.png' : 'https://pt-starimg.didistatic.com/static/starimg/img/yoewm9HxNV1646825268816.png'}}"
        />
      </view>
    </view>
    <view class="es-train-information-item" wx:style="align-items: center;">
      <view class="es-train-code"
        >{{ trainCode }}
        <!-- <view class="silent" wx:if="{{showSilent}}">
          <image
            wx:style="width: 12px; height: 12px"
            src="{{'https://pt-starimg.didistatic.com/static/starimg/img/WE1bYvYxbj1646825268807.png'}}"
          />
        </view> -->
      </view>
      <view class="es-train-info" bindtap="onClick">时刻表</view>
      <view class="es-train-info-travel-time">{{ travelTime }}</view>
    </view>
    <view class="es-train-information-item" wx:style="text-align: right">
      <view class="es-train-info-date">{{ endTime.date }} {{ endTime.week }}</view>
      <view class="es-train-info-time">{{ endTime.time }}</view>
      <view class="es-train-station-name" wx:style="justify-content: flex-end">
        <image
          wx:style="width: 12px; height: 12px; margin-right: 2px"
          src="{{isEndStation ? 'https://pt-starimg.didistatic.com/static/starimg/img/VUyQ5LqzAi1646826526234.png' : 'https://pt-starimg.didistatic.com/static/starimg/img/yoewm9HxNV1646825268816.png'}}"
        />
        {{ toStationName }}
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFullDate, formatDate, getWeek, parseDate } from '@/utils/baseDate'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import { STORAGE_TRAIN_INFO } from '@/utils/train-storage'
  import { generateDurationFunc } from '@/utils/timeDeal'

  /**
   * @props.trainInfo {Object} 当前所选坐席
   * @props.trainInfo.start_station_name {String}
   * @props.trainInfo.end_station_name {String}
   * @props.trainInfo.from_station_name {String}
   * @props.trainInfo.to_station_name {String}
   * @props.trainInfo.train_code {String}
   * @props.trainInfo.start_time {String}
   * @props.trainInfo.arrive_time {String}
   */
  createComponent({
    props: {
      trainInfo: Object
    },
    data: {},
    //if (this.selectSeatInfo?.seat_type_name) {
    //   return this.selectSeatInfo
    // } else {
    //   return getStorage(STORAGE_TRAIN_INFO)?.selectSeatInfo || {}
    // }
    methods: {
      onClick() {
        this.triggerEvent('click')
      },
      getTimeFromDate(date) {
        if (date != null && date != '') {
          var time = parseDate(date)
          return formatDate(time, 'hh:mm')
        } else {
          return '--'
        }
      },
    },
    computed: {
      trainInfoMap() {
        let info
        if (this.trainInfo?.start_time) {
          info = this.trainInfo || {}
        } else {
          const { trainInfo } = getStorage(STORAGE_TRAIN_INFO) || {}
          info = trainInfo
        }
        return info
      },
      startTime() {
        const trainInfo = this.trainInfoMap
        return {
          date: formatDate(trainInfo?.start_time, 'MM月dd日'),
          week: getWeek(parseDate(trainInfo?.start_time)),
          time: this.getTimeFromDate(trainInfo?.start_time)
        }
      },
      endTime() {
        const trainInfo = this.trainInfoMap
        return {
          date: formatDate(trainInfo?.arrive_time, 'MM月dd日'),
          week: getWeek(parseDate(trainInfo?.arrive_time)),
          time: this.getTimeFromDate(trainInfo?.arrive_time)
        }
      },
      travelTime() {
        const trainInfo = this.trainInfoMap
        if (trainInfo?.travel_time_name) {
          const str = trainInfo?.travel_time_name
          return str.substring(2, str.length)
        } else {
          return ''
        }
      },
      fromStationName() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.from_station_name
      },
      toStationName() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.to_station_name
      },
      isStartStation() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.is_start_station
      },
      isEndStation() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.is_end_station
      },
      trainCode() {
        const trainInfo = this.trainInfoMap
        return trainInfo?.train_code
      },
      showSilent() {
        return this.trainInfoMap?.special_flag > 0
      }
    }
  })
</script>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-train-information
    display flex
    justify-content space-between
    .es-train-information-item
      display flex
      flex-direction column
      justify-content space-between
      min-width 70px
      .es-train-info-date, .es-train-info-travel-time
        font-size 13px
        color $train-color-666
      .es-train-info-time
        font-size 24px
        color $train-color-333
        font-weight 700
      .es-train-code, .es-train-station-name
        font-size 13px
        color $train-color-333
        display flex
        align-items center
        font-weight 600
      // .silent
      //   background RGB(20, 115, 255, 0.1)
      //   border-radius 2px
      //   width 12px
      //   height 12px
      //   line-height 10px
      //   text-align center
      //   align-self center
      //   box-sizing border-box
      //   margin-left 2px
      .es-train-info
        position relative
        width 68px
        height 20px
        color #3C5A86
        font-size 13px
        border-radius 8px
        text-align center
        line-height 20px
        margin-bottom 0.5px
        &::after
          position absolute
          content: ""
          width 200%
          height 200%
          box-sizing border-box
          border 1px solid #3C5A86
          transform-origin 0 0
          transform scale(0.5)
          border-radius 16px
          top 0
          left 0
      .es-train-divider
        border-bottom 1px solid #CAD0DA
        width 100%
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>